import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebookSquare } from "react-icons/fa";
import "@fontsource/chivo";

const menuItems = [
  { label: "Da Vittorio", path: "/da-vittorio" },
  { label: "Prenota", path: "/prenota" },
  { label: "Tariffe", path: "/tariffe" },
  // { label: "Snack-Bar", path: "/snack-bar" },
  { label: "Regolamento", path: "/regolamento" },
  { label: "Contatti", path: "/contatti" },
];

const Footer = () => {
  return (
    <footer className="bg-[#f8f8f8] text-black py-10 px-6 border-t border-gray-200">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-6 text-center">

        {/* Footer Menu */}
        <ul className="flex flex-wrap justify-center gap-6 text-sm sm:text-base font-[chivo]">
          {menuItems.map(({ label, path }, index) => (
            <li key={index}>
              <Link
                to={path}
                className="hover:text-[#009FB7] transition-colors duration-200"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Social Icons */}
        <div className="flex gap-6">
          <a
            href="https://www.instagram.com/lidodavittorio/?hl=it"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram
              size={28}
              className="text-pink-500 hover:scale-110 transition duration-300"
            />
          </a>
          <a
            href="https://www.facebook.com/lidovittorio/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookSquare
              size={28}
              className="text-blue-600 hover:scale-110 transition duration-300"
            />
          </a>
        </div>

        {/* Legal Info with inline links */}
        <div className="flex flex-wrap justify-center gap-4 text-xs sm:text-sm font-[chivo] text-center">
          <p>
            © 2025 Lido Da Vittorio. Tutti i Diritti Riservati. | DA VITTORIO SAS - Partita IVA: 09646541210 |{" "}
            <a
              href="/privacy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-[#009FB7]"
            >
              Privacy Policy
            </a>{" "}
            |{" "}
            <a
              href="/cookie.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-[#009FB7]"
            >
              Cookie Policy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
